import { Skeleton } from '@mui/material';
import React from 'react';

interface IMainImageSkeletonProps {
    containerHeight: number;
}

const MainImageSkeleton = (props: IMainImageSkeletonProps) => {
    return (
        <Skeleton
            variant="rectangular"
            animation="wave"
            height={`calc(${props.containerHeight} - 50px)`}
            style={{ width: '100%' }}
        />
    );
};

export default MainImageSkeleton;
